export const DEFAULT_MAX_SUMMARY_GENERATION_DURATION = 10000; // milliseconds
export const DEFAULT_CHAT_WRAPPING_DURATION = 20000; // milliseconds

export const TASK_WRAPUP_REASON = "CallEnded";
export const TASK_COMPLETE_REASON = "SessionEnded";
